<span class="flex items-center main-container">
  <span class="flex items-center">
   @if ($loading()) {
    <p>{{ t('loading_records')() }}...</p>&nbsp;<app-spinner />
   }
   @else if ($visibleItems().length === 0) {
    <p>{{ t('no_records')() }}</p>
   }
   @else if ($items().length === 1) {
    <p>1 {{ t('record')().toLowerCase() }}</p>
   }
   @else if ($pagesAmount() === 1) {
    <p>{{ $visibleItems().length | commas }} {{ t('records')().toLowerCase() }}</p>
   }
   @else {
    <p>{{ $registriesAmountText() | commas }}</p>
   }
  </span>

  <span class="buttons flex items-center">
    <app-button
      icon="skip-next"
      [iconScale]="-1.4"
      [disabled]="$currentPage() === 1 || $pagesAmount() < 2 || $loading()"
      (click)="changePage(1)"
    />

    <app-button
      icon="play"
      [iconScale]="-1.1"
      [disabled]="$currentPage() === 1 || $pagesAmount() < 2 || $loading()"
      (click)="changePage('previous')"
    />

    <span class="numbers">
      <button
        [disabled]="$loading()"
        [class.disab]="$loading()"
        [class.current]="$leftValue() === $currentPage()"
        (click)="changePage($leftValue())"
      >{{ $leftValue() }}</button>

      @if ($pagesAmount() > 1) {
      <button
        [disabled]="$loading()"
        [class.disab]="$loading()"
        [class.current]="$middleValue() === $currentPage()"
        (click)="changePage($middleValue())"
      >{{ $middleValue() }}</button>
      }

      @if ($pagesAmount() > 2) {
      <button
        [disabled]="$loading()"
        [class.disab]="$loading()"
        [class.current]="$rightValue() === $currentPage()"
        (click)="changePage($rightValue())"
        >{{ $rightValue() }}</button>
      }
    </span>

    <app-button
      icon="play"
      [iconScale]="1.1"
      [disabled]="$currentPage() === $pagesAmount() || $pagesAmount() < 2 || $loading()"
      (click)="changePage('next')"
    />

    <app-button
      icon="skip-next"
      [iconScale]="1.4"
      [disabled]="$currentPage() === $pagesAmount() || $pagesAmount() < 2 || $loading()"
      (click)="changePage($pagesAmount())"
    />
  </span>
</span>
